import React from 'react';
import { CalloutBlock } from '../CalloutBlock/CalloutBlock';
import BabyCenter from '../../assets/img/press-icons/press-baby-center.svg';
import Costco from '../../assets/img/press-icons/press-costco.svg';
import GeekWire from '../../assets/img/press-icons/press-geek-wire.svg';
import Inc from '../../assets/img/press-icons/press-inc.svg';
import People from '../../assets/img/press-icons/press-people.svg';
import TechCrunch from '../../assets/img/press-icons/press-tech-crunch.svg';
import Today from '../../assets/img/press-icons/press-today.svg';
import WSJ from '../../assets/img/press-icons/press-wsj.svg';

export default function HomepageSectionPressBar(): React.ReactElement {
  return (
    <CalloutBlock>
      <div className="gik-press-bar">
        <div className="gik-press-bar__title">As seen in..</div>
        <div className="gik-press-bar__logos">
          <div className="gik-press-bar__logo">
            <Today className="gik-press-bar__SVG" viewBox="0 0 150 51" />
          </div>
          <div className="gik-press-bar__logo">
            <TechCrunch className="gik-press-bar__SVG" viewBox="0 0 204 51" />
          </div>
          <div className="gik-press-bar__logo gik-press-bar__people">
            <People className="gik-press-bar__SVG" viewBox="0 0 115 60" />
          </div>
          <div className="gik-press-bar__logo">
            <WSJ className="gik-press-bar__SVG" viewBox="0 0 253 51" />
          </div>
          <div className="gik-press-bar__logo">
            <Costco className="gik-press-bar__SVG" viewBox="0 0 176 51" />
          </div>
          <div className="gik-press-bar__logo">
            <Inc className="gik-press-bar__SVG" viewBox="0 0 93 51" />
          </div>
          <div className="gik-press-bar__logo">
            <BabyCenter className="gik-press-bar__SVG" viewBox="0 0 198 51" />
          </div>
          <div className="gik-press-bar__logo">
            <GeekWire className="gik-press-bar__SVG" viewBox="0 0 137 51" />
          </div>
        </div>
      </div>
    </CalloutBlock>
  );
}
